import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import { MATCH_PROVENANCE_LEGEND_ITEMS } from './RentalPortalMatchProvenanceLegend.constants'
import { RentalPortalMatchProvenanceLegendItem } from './RentalPortalMatchProvenanceLegendItem'

import * as styles from './RentalPortalMatchProvenanceLegend.module.css'

function RentalPortalMatchProvenanceLegend() {
  const { t } = useTranslation()

  return (
    <span className={styles.RentalPortalMatchProvenanceLegend}>
      <Text className={styles.title}>
        {t('RentalPortal.MatchProvenanceLegendTitleKey')}
      </Text>
      {MATCH_PROVENANCE_LEGEND_ITEMS.map(({ labelKey, source }) => (
        <RentalPortalMatchProvenanceLegendItem
          key={source}
          labelKey={labelKey}
          source={source}
        />
      ))}
    </span>
  )
}

export default RentalPortalMatchProvenanceLegend
